import { CARD_MAPPING } from './cards/card-mapping.const'
import { CMP_MAPPING } from './cmps/cmp-mapping.const'
import { LAYOUT_MAPPING } from './layouts/layout-mapping.const'

export const CONTENT_MAPPING = {
  ...LAYOUT_MAPPING,
  ...CARD_MAPPING,
  ...CMP_MAPPING,
}
